// Card #1797 — the Blank mode type: a single logo, centred on both axes,
// on an otherwise empty board (design pare-down, 2026-08-20).
//
// This is #1798's universal "nothing to show" fallback (Jaybill,
// 2026-08-20: "NEVER show an error message on the scoreboard") — so unlike
// every other layout in this directory, it must be safe to render from
// LITERALLY nothing: no `fields`, no `payload`, no class, no ride, not even
// a successful poll. Accordingly it takes a bare `logoAssetUrl` string that
// may be absent/unresolved/garbage (card #2308: score-api resolves a mode's
// org-scoped logoAsset id into this URL server-side, falling back to null
// on any miss) plus the view's own `theme`, and resolves them through
// blankLogoAssets.js's fallback chain — never trusts either as a path
// beyond a plain <img> src, and can't throw on any input (see that file's
// resolveBlankLogoAsset). ScoreboardContent.jsx dispatches here for
// LAYOUT_FAMILY.BLANK BEFORE its shared "no fields yet" empty-state gate,
// specifically so this never needs a composed response to render.
//
// Card #2311 (PROD HOTFIX): resolveBlankLogoAsset can now return `null`
// (stored pick -> theme logo -> NOTHING, no Fox Village mark left in the
// chain), so this renders no <img> at all in that case — an empty logo area
// is the correct, intended render, never a broken/empty-src image tag.
import { resolveBlankLogoAsset } from "./blankLogoAssets";
import "./BlankLayout.css";

export default function BlankLayout({ logoAssetUrl, theme }) {
  const resolvedLogoUrl = resolveBlankLogoAsset(logoAssetUrl, theme);
  return (
    // #1835: `data-blank-source` is how a test (or an operator inspecting a
    // kiosk) tells "the board ROUTED to Blank on purpose" ("layout") apart
    // from "a layout threw and ScoreboardErrorBoundary caught it"
    // ("render-error", ScoreboardErrorBoundary.jsx). Both share the
    // scoreboard-blank/-logo testids and the same logo key by design, so
    // without this a broken route and a caught throw are indistinguishable.
    <div className="scoreboard-blank" data-testid="scoreboard-blank" data-blank-source="layout">
      {/* alt="" — decorative on a board nobody reads with a screen reader;
          the src itself can never be broken (see resolveBlankLogoAsset). */}
      {resolvedLogoUrl ? (
        <img
          className="scoreboard-blank__logo"
          src={resolvedLogoUrl}
          alt=""
          data-testid="scoreboard-blank-logo"
        />
      ) : null}
    </div>
  );
}
